import { AxiosHeaders, type AxiosInstance } from "axios";

declare module "axios" {
	export interface InternalAxiosRequestConfig {
		withOrgUnit?: boolean;
	}
}

/**
 * На backend части есть проверка 
 * если передается в заголовках `x-api-key` или авторизация, то id точки будет браться из них 
 * вне зависимости от того что передается в заголовках `x-org-unit`
 * @param {AxiosInstance} instance - Axios instance
 * @returns {void}
 */
export const useOrgUnitInterceptor = (instance: AxiosInstance) => {
	instance.interceptors.request.use((req) => {
		if (req.withOrgUnit === false) return req;

		const orgUnitId = localStorage.getItem("orgID"); // @TODO: get from org unit store (wildcard)?

		if (!req.headers) req.headers = new AxiosHeaders();
		if (orgUnitId) req.headers["x-org-unit"] = orgUnitId;

		return req;
	});
};
